export default "__VITE_ASSET__Bu$ThYrM__"